import { HttpInterceptorFn } from '@angular/common/http';

/**
 * Interceptor HTTP para agregar automáticamente el token de autenticación
 * a todas las peticiones HTTP
 * 
 * Beneficios:
 * - Centraliza la lógica de headers de autenticación
 * - Elimina código duplicado en servicios
 * - Facilita el mantenimiento
 * 
 * Nota: Excluye rutas de autenticación (login, register) que no requieren token.
 * El interceptor solo agrega el token si existe, por lo que las peticiones sin token
 * continuarán normalmente.
 */
export const authInterceptor: HttpInterceptorFn = (req, next) => {
  // Excluir rutas de autenticación que NO requieren token (login, register)
  const publicAuthRoutes = ['/Auth/Login', '/Auth/Register'];
  const isPublicAuthRoute = publicAuthRoutes.some(route => req.url.includes(route));

  // Si es una ruta pública de autenticación, continuar sin token
  if (isPublicAuthRoute) {
    return next(req);
  }

  // Obtener el token del localStorage
  const token = localStorage.getItem('token');

  // Log detallado para debugging
  console.log('[AuthInterceptor] Procesando petición:', {
    url: req.url,
    method: req.method,
    hasToken: !!token,
    tokenLength: token?.length || 0,
    tokenPreview: token ? `${token.substring(0, 20)}...` : 'N/A',
    isPublicRoute: isPublicAuthRoute
  });

  // Si hay token, agregarlo al header Authorization
  if (token) {
    const clonedRequest = req.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`
      }
    });
    
    // Verificar que el header se agregó correctamente
    console.log('[AuthInterceptor] Header Authorization agregado:', clonedRequest.headers.has('Authorization'));
    
    return next(clonedRequest);
  }

  // Si no hay token, continuar con la petición original
  console.warn('[AuthInterceptor] ⚠️ No hay token en localStorage, continuando sin token');
  return next(req);
};
